import { Sparkles } from 'lucide-react'
import { useTranslation } from '../lib/i18n'

/**
 * Small "Pro" marker for Pro courses and lessons (course cards, lesson rows,
 * curriculum lists, mega menu, search results). A dependency-light leaf (no
 * Clerk / Convex) so the landing page and nav can use it without pulling the
 * paywall runtime into their bundles.
 */
export function ProBadge({ className }: { className?: string }) {
  const { t } = useTranslation()
  return (
    <span
      className={className ? `pro-badge ${className}` : 'pro-badge'}
      title={t('pro.badgeLabel')}
    >
      <Sparkles size={11} strokeWidth={2.5} aria-hidden="true" />
      {t('pro.badge')}
      <span className="sr-only">{` - ${t('pro.badgeLabel')}`}</span>
    </span>
  )
}
